/* eslint-disable camelcase */

import { createAction } from '@reduxjs/toolkit';
import { DashboardWidget } from 'types';
import { Condition, DataNode, Tree, ValueNode } from 'utils/parserTree';

export const enterEditWidgetMode = createAction<{ widget: DashboardWidget; widgetIndex: number }>(
  'DASHBOARD_EDIT/ENTER_EDIT_MODE'
);
export const exitEditWidgetMode = createAction('DASHBOARD_EDIT/EXIT_EDIT_MODE');

export const saveWidget = createAction<{ multimetric?: boolean; redirect?: boolean }>(
  'DASHBOARD_EDIT/SAVE_WIDGET'
);
export const saveWidgetCustomerConfig = createAction<{ multimetric?: boolean; redirect?: boolean }>(
  'DASHBOARD_EDIT/SAVE_WIDGET_CUSTOMER_CONFIG'
);

export const setFilterSearch = createAction<{ filterSearch: string; metricIndex: number | null }>(
  'DASHBOARD_EDIT/SET_FILTERS_SEARCH'
);

export type SelectedFilterPayload = { node: ValueNode };

export const addSelectedFilter = createAction<SelectedFilterPayload>(
  'DASHBOARD_EDIT/ADD_SELECTED_FILTER'
);
export const removeSelectedFilter = createAction<SelectedFilterPayload>(
  'DASHBOARD_EDIT/REMOVE_SELECTED_FILTER'
);
export const clearSelectedFilters = createAction('DASHBOARD_EDIT/CLEAR_SELECTED_FILTERS');

export type SelectedFieldPayload = { node: DataNode };

export const addSelectedField = createAction<SelectedFieldPayload>(
  'DASHBOARD_EDIT/ADD_SELECTED_FIELD'
);
export const removeSelectedField = createAction<SelectedFieldPayload>(
  'DASHBOARD_EDIT/REMOVE_SELECTED_FIELD'
);
export const clearSelectedFields = createAction('DASHBOARD_EDIT/CLEAR_SELECTED_FIELD');

export type AddValueToTreePayload = {
  field: string;
  value: string;
  label?: string;
  isSingleValue?: boolean;
  metricIndex: number | null;
};

export const addValueToTree = createAction<AddValueToTreePayload>(
  'DASHBOARD_EDIT/ADD_VALUE_TO_TREE'
);

export type AddValueToGroupPayload = {
  nodes: ValueNode[];
  group: DataNode;
  metricIndex: number | null;
};
export const addValuesToExistingGroup = createAction<AddValueToGroupPayload>(
  'DASHBOARD_EDIT/ADD_VALUE_TO_EXISTING_GROUP'
);
export const addValuesToNewGroup = createAction<AddValueToGroupPayload>(
  'DASHBOARD_EDIT/ADD_VALUE_TO_NEW_GROUP'
);

export type RemoveValuePayload = {
  value: string;
  metricIndex: number | null;
  field?: string;
  fieldId?: string;
};
export const removeValueFromTree = createAction<RemoveValuePayload>(
  'DASHBOARD_EDIT/REMOVE_VALUE_FROM_TREE'
);

export type RemoveValuesPayload = {
  values: string[];
  field?: string;
  metricIndex: number | null;
};
export const removeValuesFromTree = createAction<RemoveValuesPayload>(
  'DASHBOARD_EDIT/REMOVE_VALUES_FROM_TREE'
);

export const removeFieldFromTree = createAction<{
  field: string;
  metricIndex: number | null;
  id?: string;
}>('DASHBOARD_EDIT/REMOVE_FIELD');

export type AddAndRemoveValuesToTreePayload = {
  valuesToAdd: AddValueToTreePayload[];
  fieldsToRemove: string[];
  metricIndex: number | null;
};

export const addAndRemoveValuesToTree = createAction<AddAndRemoveValuesToTreePayload>(
  'DASHBOARD_EDIT/ADD_AND_REMOVE_VALUE_TO_TREE'
);

export type ChangeConditionalTypePayload = {
  node: DataNode;
  condition: Condition;
  metricIndex: number | null;
};
export const changeConditionalType = createAction<ChangeConditionalTypePayload>(
  'DASHBOARD_EDIT/CHANGE_CONDITIONAL_TYPE'
);

export const changeConditionalByFieldValue = createAction<{
  field: string;
  condition: Condition;
  metricIndex: number | null;
}>('DASHBOARD_EDIT/CHANGE_CONDITIONAL_BY_FIELD_VALUE');

export const setTree =
  createAction<{ tree: Tree; metricIndex: number | null }>('DASHBOARD_EDIT/SET_TREE');

export const addValuesToGroup = createAction<{ nodes: ValueNode[]; metricIndex: number | null }>(
  'DASHBOARD_EDIT/ADD_VALUE_TO_GROUPS'
);

export const removeValuesFromGroup = createAction<{
  nodes: ValueNode[];
  metricIndex: number | null;
}>('DASHBOARD_EDIT/REMOVE_VALUE_FROM_GROUPS');

export const addFieldsToGroup = createAction<{ nodes: DataNode[]; metricIndex: number | null }>(
  'DASHBOARD_EDIT/ADD_FIELD_TO_GROUPS'
);

export const removeFieldsFromGroup = createAction<{
  nodes: DataNode[];
  metricIndex: number | null;
}>('DASHBOARD_EDIT/REMOVE_FIELD_FROM_GROUPS');

export const requestTreeFiltersToogle = createAction<{ value: boolean }>(
  'DASHBOARD_EDIT/REQUEST_TREE_FILTERS'
);

export const addAllValuesToField = createAction<{
  nodes: { value: string; label?: string }[];
  field: string;
  metricIndex: number | null;
}>('DASHBOARD_EDIT/ADD_ALL_VALUES_TO_FIELD');

export const clearTree = createAction('DASHBOARD_EDIT/CLEAR_TREE');

export const selectMetricIndex = createAction<number>('DASHBOARD_EDIT/SELECT_METRIC_INDEX');

export const setEditWidgetGroupBy = createAction<string>('DASHBOARD_EDIT/SET_EDIT_WIDGET_GROUP_BY');
